<div class="row">
    <div class="col" *ngIf="model">
        <div class="pt-2">
            <button type="button" *ngIf="isActive" (click)="cancel()" class="btn bc-button btn-sm mr-2" translate
                [showIfPrivileges]="'GroupClasses.canManageClasses'" [clubIds]="model.club.id">
                GroupClassDetails.BtnCancel
            </button>
            <ng-container *ngIf="isCancelled">
                <button type="button" (click)="restore()" class="btn bc-button btn-sm mr-2"
                    *bcIfPrivileges="'GroupClasses.canManageClasses'; clubIds model.club.id" translate>
                    GroupClassDetails.BtnRestore
                </button>
            </ng-container>
            <button type="button" *ngIf="canSubstitute" (click)="substitute()" class="mr-2 btn bc-button btn-sm"
                translate [showIfPrivileges]="'GroupClasses.canManageClasses'" [clubIds]="model.club.id">
                GroupClassDetails.BtnSubstitute
            </button>
            <button type="button" *ngIf="canCancelSubstitution" (click)="cancelSubstitution()"
                class="mr-2 btn btn-light btn-sm" translate [showIfPrivileges]="'GroupClasses.canManageClasses'"
                [clubIds]="model.club.id">
                GroupClassDetails.BtnCancelSubstitution
            </button>

            <div class="btn-group" dropdown>
                <button translate id="button-more-options" dropdownToggle type="button"
                    class="btn bc-button btn-sm ic_more_primary dropdown-toggle" aria-controls="dropdown-more-options"
                    [showIfPrivileges]="'GroupClasses.canManageClasses'">
                    GroupClassDetails.MoreOptionsButton <span class="caret"></span>
                </button>
                <ul id="dropdown-more-options" *dropdownMenu class="dropdown-menu p-0" role="menu"
                    aria-labelledby="button-more-options">
                    <li role="menuitem" class=" ml-2 cursor-pointer drop-down-text" (click)="edit()"
                        [showIfPrivileges]="'GroupClasses.canManageClasses'" translate [clubIds]="model.club.id">
                        <span class="drop-down-text" translate>GroupClassDetails.BtnEdit</span>
                    </li>
                    <li role="menuitem" class="ml-2 cursor-pointer drop-down-text" *ngIf="isDeleteAvailable"
                        (click)="delete()" translate [showIfPrivileges]="'GroupClasses.canManageClasses'"
                        [clubIds]="model.club.id">
                        GroupClassDetails.BtnDelete

                    </li>
                    <li role="menuitem" class="ml-2 cursor-pointer drop-down-text" *ngIf="canCreateSubRequest"
                        (click)="requestSubstitution()" translate [showIfPrivileges]="'GroupClasses.canManageClasses'"
                        [clubIds]="model.club.id">
                        GroupClassDetails.BtnCreateSubRequest
                    </li>
                    <li role="menuitem" class="ml-2 cursor-pointer drop-down-text"
                        [showIfPrivileges]="'GroupClasses.canViewClassHistory'" [clubIds]="model.club.id"
                        (click)="showItemHistory()" translate>
                        GroupClassDetails.BtnShowItemHistory
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
